import React, { useEffect, useState } from "react";
import "./categories.css";
import axiosInstance from "../../apis/config";
import { Link } from "react-router-dom";

const Categories = () => {
  const [allCategories, setAllCategories] = useState([]);

  useEffect(() => {
    axiosInstance
      .get(`/categories`, {})
      .then((res) => {
        const shuffledCategories = res.data.data.sort(
          () => Math.random() - 0.5
        );
        setAllCategories(shuffledCategories);
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);

  return (
    <section
      className="category"
      aria-labelledby="categories-heading"
      itemScope
      itemType="https://schema.org/ItemList"
    >
      <h2 id="categories-heading" className="sr-only">
        Security & IT Product Categories in Nakuru, Kenya
      </h2>

      <div className="container">
        <div className="category-item-container">
          {allCategories &&
            allCategories.map((cat, index) => (
              <div
                className="category-item"
                key={cat._id}
                itemProp="itemListElement"
                itemScope
                itemType="https://schema.org/ProductCategory"
              >
                <meta itemProp="position" content={index + 1} />
                <div className="category-img-box">
                  <img
                    src={cat.image[0]?.url}
                    alt={`${cat.name} security products in Nakuru`}
                    width="50"
                    style={{ maxHeight: "45px" }}
                    itemProp="image"
                  />
                </div>
                <div className="category-content-box">
                  <div className="category-content-flex d-flex flex-wrap">
                    <h3
                      className="category-item-title"
                      itemProp="name"
                      style={{ margin: 0 }} // Maintain exact visual style
                    >
                      {cat.name}
                    </h3>

                    <p
                      className="category-item-amount mb-0"
                      aria-label={`${cat.products_id?.length} products available`}
                    >
                      ({cat.products_id?.length})
                    </p>
                  </div>
                  <Link
                    to={`/shop?page=1&brand=all&category=${cat._id}&sort=0&price=0`}
                    className="category-btn"
                    aria-label={`Browse all ${cat.name} security products`}
                    itemProp="url"
                  >
                    Show all
                  </Link>
                </div>
              </div>
            ))}
        </div>
      </div>
    </section>
  );
};

export default Categories;
